<template>
  <div
    :class="[
      $style.container,
      center ? $style.center : '',
      shadowless ? $style.shadowless : '',
      borderless ? $style.borderless : '',
      radiusless ? $style.radiusless : '',
    ]"
  >
    <table :class="$style.table">
      <template v-if="data.length > 0">
        <thead>
          <slot name="thead"></slot>
        </thead>
        <tbody :class="hoverable && $style.hoverable">
          <slot name="tbody" :data="data"></slot>
        </tbody>
        <tfoot>
          <slot name="tfooter"></slot>
        </tfoot>
      </template>

      <template v-else>
        <tbody>
          <tr>
            <td colspan="0">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p :class="$style.noDataText">
                    {{ noDataText || 'No data available' }}
                  </p>
                </div>
              </section>
            </td>
          </tr>
        </tbody>
      </template>
    </table>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

@Component({
  components: {},
})
export default class DataTable extends Vue {
  @Prop({ default: [] })
  public data!: any[];

  @Prop({ default: false })
  public hoverable!: boolean;

  @Prop({ default: '' })
  public noDataText!: string;

  @Prop({ default: false })
  public center!: boolean;

  @Prop({ default: false })
  public shadowless!: boolean;

  @Prop({ default: false })
  public borderless!: boolean;

  @Prop({ default: false })
  public radiusless!: boolean;
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 1rem;
  box-shadow: 0 2px 2px $grey-border;
  border: 0.5px solid $grey-border;
  border-radius: 6px;
  background: #ffffff;
  overflow-x: auto;
  overflow: visible;

  .table {
    width: 100%;

    thead {
      tr {
        // border-bottom: 1px solid $grey-border;

        td,
        th {
          padding: 1rem;
          color: $grey-light-2;
          font-weight: 500;
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid $grey-border;

        td,
        th {
          padding: 1.25rem 1rem;

          a {
            font-weight: 700;
            color: #1d70b8;

            &:hover {
              cursor: default;
              color: $primary;
              text-decoration: underline;
              text-decoration-thickness: 2px;
            }
          }
        }
      }

      tr:last-child {
        border-bottom: none;
      }
    }

    tr > td:last-child {
      text-align: right;
    }
  }
}

.hoverable {
  tr {
    &:hover {
      cursor: pointer;
      background-color: #f7fbff;
    }
  }
}

.shadowless {
  box-shadow: none;
}

.borderless {
  border: none;
}

.radiusless {
  border-radius: 0;
}

.noDataText {
  font-size: 18px;
  font-weight: bold;
  color: #9f9f9f;
}
</style>
